import { cn } from "@/lib/utils";

/** Eyebrow, a heading of a few words and one line under it. Keeps the type scale in one place. */
export default function SectionHeading({ eyebrow, title, line, align = "left", as: Tag = "h2", id, className }) {
  const big = Tag === "h1";
  return (
    <div id={id} className={cn("max-w-[38rem]", align === "center" && "mx-auto text-center", className)}>
      {eyebrow ? <p className="text-eyebrow uppercase text-lime-300 mb-3">{eyebrow}</p> : null}
      <Tag className={cn("font-heading font-extrabold", big ? "text-h1" : "text-h2")}>{title}</Tag>
      {line ? <p className="text-zinc-400 text-base lg:text-[17px] leading-[1.55] mt-3">{line}</p> : null}
    </div>
  );
}
